<nav class="scheduling-nav" [class.hidden]="isHidden" aria-label="Scheduling navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a
            #navLink
            routerLink="/scheduling/schedule-groups"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Default Schedules
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/scheduling/user-assign-schedules"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Assign Schedules
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/scheduling/scheduling-sync"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Sync Schedules
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>